import React from 'react';

import { cn } from './cn';

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
}

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, label, id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
    return (
      <div className="flex flex-col gap-1.5">
        {label && (
          <label htmlFor={inputId} className="text-sm font-medium text-gray-700">
            {label}
          </label>
        )}
        <textarea
          id={inputId}
          ref={ref}
          className={cn(
            'rounded-md border border-gray-300 bg-surface px-3 py-2.5 text-sm text-text-primary outline-none transition-all duration-200 placeholder:text-gray-400 focus:border-info-500 focus:ring-2 focus:ring-info-500/20 focus:shadow-sm resize-y min-h-24',
            className
          )}
          {...props}
        />
      </div>
    );
  }
);
TextArea.displayName = 'TextArea';
